import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

export const useDayjsFormatter = (format: string = undefined, date: string = undefined): string => {
    if (date) {
        return dayjs(date).format(format ?? "L");
    }
    return dayjs().format(format ?? "L");
};

export default useDayjsFormatter;
